import { FiArrowDown, FiArrowUpRight, FiCheck, FiCompass, FiLayers, FiUsers } from 'react-icons/fi';

const HomePage = () => {
  const advantages = [
    { icon: FiCompass, title: 'Современная методика', text: 'Понятно о сложном — через практику и живой диалог.' },
    { icon: FiUsers, title: 'Мини-группы', text: 'От 4 до 6 человек: внимание к каждому и среда для роста.' },
    { icon: FiLayers, title: 'Системный подход', text: 'Диагностика знаний до и после обучения.' },
    { icon: FiCheck, title: 'Результат', text: 'Гибкий график, поддержка и честная обратная связь.' }
  ];

  return (
    <div className="home-page">
      <section className="hero-section">
        <div className="container hero-grid">
          <div className="hero-copy">
            <p className="eyebrow"><span /> образовательная организация нового поколения</p>
            <h1>Знания без<br /><em>пробелов.</em></h1>
            <p className="hero-lead">
              Центр знаний «#БезПробелов» — место, где сложные вопросы обществознания становятся ясными, а обучение превращается в уверенный шаг вперёд.
            </p>
            <div className="hero-actions"><a className="button button--gold" href="#about">Узнать о центре <FiArrowUpRight /></a><a className="text-link" href="#advantages">Наш подход <FiArrowDown /></a></div>
            <div className="hero-note"><span className="hero-note__line" /><span>Компетентность · качество · сотрудничество</span></div>
          </div>
          <div className="hero-visual">
            <div className="hero-logo-frame">
              <div className="hero-logo-orbit" />
              <div className="hero-logo-mark">#</div>
              <div className="hero-logo-name">БезПробелов</div>
              <div className="hero-logo-subtitle">центр знаний</div>
            </div>
            <div className="hero-stamp"><strong>2016</strong><span>Калуга</span></div>
            <div className="hero-caption"><span>образование<br />с характером</span></div>
          </div>
        </div>
      </section>

      <section className="intro-section" id="about">
        <div className="container intro-grid"><div><p className="eyebrow"><span /> о центре</p><h2>Учиться — значит<br /><em>видеть больше.</em></h2></div><div className="intro-text"><p>
              Это изучение сложных вопросов обществознания. Здесь вы узнаете о духовной сфере общества,
              развитии экономики, особенностях политической и правовой системы, а также много об устройстве
              окружающего мира.
            </p><div className="quote">«Мы дорожим своей репутацией — и каждым результатом»</div></div></div>
      </section>

      <section className="advantages-section" id="advantages"><div className="container"><div className="section-heading"><div><p className="eyebrow"><span /> почему мы</p><h2>Планка, которую<br /><em>держим всегда.</em></h2></div><p>Мы создаём пространство, в котором хочется думать, задавать вопросы и становиться сильнее.</p></div><div className="advantage-grid">{advantages.map(({ icon: Icon, title, text }) => <article className="advantage-card" key={title}><div className="advantage-title"><Icon className="advantage-icon" /><h3>{title}</h3></div><p>{text}</p></article>)}</div></div>
      </section>
      <section className="manifesto-section"><div className="container manifesto"><p className="eyebrow"><span /> наша философия</p><p>Не просто подготовить<br /><em>к экзамену.</em> Подготовить<br />к <strong>возможностям.</strong></p><FiArrowUpRight /></div></section>
    </div>
  );
};

export default HomePage;
